// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"21":"ac1d7578","114":"2cece489","248":"5b06b7de","441":"0809eb74","442":"32a00ae7","639":"afb572a9","870":"b5b1f5ca"}[chunkId] + ".chunk.js";
};